<template>
	<v-row>
		<v-col>
			<v-autocomplete
				v-model="hour"
				:items="hours"
				:error="typeof $attrs['error-messages'] !== 'undefined'"
				:prepend-icon="$attrs['prepend-icon']"
				:label="$gettext('Hour')"
				variant="outlined"
				@update:model-value="update"
			/>
		</v-col>
		<v-col>
			<v-autocomplete
				v-model="minute"
				:items="minutes"
				:error="typeof $attrs['error-messages'] !== 'undefined'"
				:label="$gettext('Minute')"
				variant="outlined"
				@update:model-value="update"
			/>
		</v-col>
	</v-row>
</template>

<script>
export default {
	name: 'TimeSelect',
	props:	{
		value: {
			type: String,
			default: null,
		}
	},

	emits: ['update:model-value',],

	data () {
		return {
			hour: null,
			minute: null,
		};
	},

	computed: {
		/**
		 * @returns {Array} a number range: [ 00, 01, 02 .. 59 ]
		 */
		minutes () {
			return [...Array(60).keys(), ].map((minute) => {
				return ('0' + minute).slice(-2);
			});
		},

		/**
		 * @returns {Array} a number range: [ 00, 01, 02 .. 23 ]
		 */
		hours () {
			return [...Array(24).keys(), ].map((hour) => {
				return ('0' + hour).slice(-2);
			});
		},

		/**
		 * Derive time string based on hours and minutes: HH:MM
		 */
		time: {
			/**
			 * @returns {string}
			 */
			get () {
				return `${this.hour}:${this.minute}`;
			},

			/**
			 * @param {string} newTime
			 * @returns {void}
			 */
			set (newTime) {
				this.hour = newTime.split(':')[0];
				this.minute = newTime.split(':')[1];
			}
		}
	},
	watch: {
		/**
		 * @param {string} newTime
		 */
		value (newTime) {
			this.time = newTime;
		}
	},
	methods: {
		/**
		 * @returns {void}
		 */
		update () {
			this.$emit('update:model-value', this.time);
		}
	}
};
</script>
